export { FocalPointImage } from "./focal-point-image";
export type { FocalPointImageProps } from "./focal-point-image.interface";
